import axios from "axios"

export function getTotalStockoutTrending (parameters) {
  return new Promise((resolve, reject) => {
    axios.post(`/analytic/api/v1/dealership/get-dealer-stock-out`, {
      period: parameters.period,
      start_date: parameters.start_date,
      end_date: parameters.end_date,
      dealer_uuid: parameters.dealer_uuid,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};